import "../style.css";
import React from "react";
import PanelContent from "../components/PanelContent";

export default function Enigme() {
  return (
    <PanelContent
      id="home_panel"
      route="/"
      frTitle = "Bienvenue"
      enTitle = "Welcome"
      frSubtitle = "Rue Pierre Jean Grosley"
      enSubtitle = "Pierre Jean Grosley Street"
      frText = "Vous êtes face à une fresque réalisée par l’artiste troyen Argadol, en collaboration avec Maître Estevez, avocat au barreau. Cette œuvre raconte une histoire marquante. Explorez le contexte de sa création, découvrez l’histoire qu’elle évoque ou apprenez-en plus sur sa réalisation artistique."
      enText = "You are facing a fresco created by the Troyes artist Argadol, in collaboration with Maître Estevez, a lawyer at the bar. This artwork tells a significant story. Explore the context of its creation, discover the story it portrays, or learn more about how it was created."
      frLeftButton="La Fresque"
      enLeftButton = "The Fresco"
      frRightButton="Le Contexte"
      enRightButton = "The Context"
      prev="/fresque"
      next="/context"
    />
  );
}
